import { useCallback } from "react";
import errorService from "../services/ErrorService";

// Хук для удобного использования ErrorService в компонентах
export const useErrorHandler = () => {
  const handleError = useCallback((error, customMessage = null) => {
    return errorService.showError(error, customMessage);
  }, []);

  const showSuccess = useCallback((message) => {
    errorService.showSuccess(message);
  }, []);

  const showWarning = useCallback((message) => {
    errorService.showWarning(message);
  }, []);

  const showInfo = useCallback((message) => {
    errorService.showInfo(message);
  }, []);

  const getErrorHistory = useCallback(() => {
    return errorService.getErrorHistory();
  }, []);

  return {
    handleError,
    showSuccess,
    showWarning,
    showInfo,
    getErrorHistory,
  };
};

export default useErrorHandler;
